import SplashPage from "./splash-page-variants/splash-page";
import SplashPage1 from "./splash-page-variants/splash-page-1";
import SplashPage2 from "./splash-page-variants/splash-page-2";
import SplashPage3 from "./splash-page-variants/splash-page-3";
import SplashPage4 from "./splash-page-variants/splash-page-4";
import SplashPage5 from "./splash-page-variants/splash-page-5";
import SplashPage6 from "./splash-page-variants/splash-page-6";
import SplashPage7 from "./splash-page-variants/splash-page-7";
import SplashPage8 from "./splash-page-variants/splash-page-8";
import { getCookie, setCookie } from "../utils/utils";
import SplashPage9 from "./splash-page-variants/splash-page-9";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { useEffect } from "react";
export const splashPageVariants = ["a", "b", "c", "d", "e", "f", "g", "h", "i"];

export const SplashPageRouter = () => {
    const dispatch = useAppDispatch();
    const credentials = useAppSelector((state) => state.user.credentials);
    
    // Check if user is already authenticated
    useEffect(() => {
        console.log('SplashPageRouter useEffect triggered');
        console.log('credentials:', credentials);
        
        // If user is already authenticated and has credentials, redirect to dashboard
        if (credentials && credentials.accessToken) {
            console.log('User has credentials, redirecting to dashboard');
            window.location.href = '/dashboard';
            return;
        }
    }, [credentials]);

    const variantCookie = getCookie('splash-page-variant');
    let v = splashPageVariants[splashPageVariants.length-1];
    const variantFromPath = window.location.pathname.split('/')[1]
    if (splashPageVariants.includes(variantFromPath)) {
        v = variantFromPath
    }

    // if (variantCookie) {
    //     const cookieVariant = variantCookie.split('-')[0];
    //     // Verify it's a valid variant
    //     if (splashPageVariants.includes(cookieVariant)) {
    //         v = cookieVariant;
    //     } else {
    //         const randomVariant = splashPageVariants[Math.floor(Math.random() * splashPageVariants.length)];
    //         v = randomVariant;
    //         setCookie('splash-page-variant', randomVariant, 30);
    //     }
    // } else {
    //     const randomVariant = splashPageVariants[Math.floor(Math.random() * splashPageVariants.length)];
    //     v = randomVariant;
    //     setCookie('splash-page-variant', randomVariant, 30);
    // }

    if (window.location.pathname !== `/${v}`) {
        window.history.replaceState({}, '', v);
    }

    return (
        <>  
            {
                v === "default" && (
                    <SplashPage />
                )
            }
            {
                v === "a" && (
                    <SplashPage1 />
                )
            }
            {
                v === "b" && (
                    <SplashPage2 />
                )
            }
            {
                v === "c" && (
                    <SplashPage3 />
                )
            }
            {
                v === "d" && (
                    <SplashPage4 />
                )
            }
            {
                v === "e" && (
                    <SplashPage5 />
                )
            }
            {
                v === "f" && (
                    <SplashPage6 />
                )
            }
            {
                v === "g" && (
                    <SplashPage7 />
                )
            }
            {
                v === "h" && (
                    <SplashPage8 />
                )
            }
            {
                v === "i" && (
                    <SplashPage9 />
                )
            }
        </>
    )
}